import React, { Component } from 'react'

import RegexVerification from './regex_verification'
import RadioGroup from '../common/radioGroup'
import RadioButton from '../common/radioButton'
import Controls from '../common/controls'
import Checkbox from '../common/checkbox'
import Modal from 'react-modal'

export default class Screener2 extends Component {
  constructor(props) {
    super(props)
    
    this.state = {
      input: { 
        gender: { value: '', type: 'radio', required: true },
        waist: { value: '', type: 'text', required: true },
        height: { value: '', type: 'text', required: true }, 
        weight: { value: '', type: 'text', required: true }, 
        health: { 
          value: {
            'pregnant' : false,
            'pregnant-diabetes': false,
            'baby-weight': false,
            'drink-male': false,
            'drink-female': false,
            'age': false,
            'blood-pressure': false,
            'cholesterol': false,
            'diabetes': false,
            'exercise': false,
            'smoke': false
          }, 
          type: 'checkbox', required: false 
        }
      },
      submitClick: false,
      modalIsOpen: false
    }

    this.focusElements = {}

    for (let name in this.state.input) {
      this.focusElements[name] = React.createRef()
    }
    
    this.openModal = this._openModal.bind(this)
    this.closeModal = this._closeModal.bind(this)
    this.next = this._next.bind(this)
  }

  handleChange(name, valueOrEvent) {
    switch (this.state.input[name].type) {
      case 'text':
        const curInputValue = valueOrEvent.target.value
        if (RegexVerification[name].test(curInputValue) || curInputValue === '') {
          this.setState({ 
            input: { ...this.state.input,
              [name]: {...this.state.input[name], 
                value: curInputValue 
              }
            }
          }, () => {
            this.props.history.replace(this.props.history.location.pathname + this.props.history.location.search, this.state.input)
          })
        }
      break
      case 'checkbox':
        this.setState({ 
          input: { ...this.state.input, 
            [name]: { ...this.state.input[name], 
              value: { ...this.state.input[name].value,
                [valueOrEvent]: !this.state.input[name].value[valueOrEvent]
              }
            }
          }
        }, () => {
          this.props.history.replace(this.props.history.location.pathname + this.props.history.location.search, this.state.input)
        })
      break
      case 'radio':
        this.setState({ 
          input: { ...this.state.input, 
            [name]: {...this.state.input[name], 
              value: valueOrEvent 
            }
          }
        }, () => {
          this.props.history.replace(this.props.history.location.pathname + this.props.history.location.search, this.state.input)
        })
      break
      default: break
    }
  }

  _next(e) {
    this.setState({ submitClick: true })
    for (let property in this.state.input) {
      if (!this.isValid(property)) {
        this.focusElements[property].focus()
        e.preventDefault()
        return
      }
    }
    return this.props.next(this.props.match.path, this.state.input)
  }

  isEmpty(name) {
    if (this.state.input[name].value === '') return true
    return false
  }

  isValid(name) {
    if (!this.state.input[name].required) {
      return true
    }
    switch (this.state.input[name].type) {
      case 'radio':
        return !this.isEmpty(name)
      case 'text':
        switch (name) {
          case 'waist':
            return (this.state.input[name].value > 10 && this.state.input[name].value < 999)
          case 'height':
            return (this.state.input[name].value > 24 && this.state.input[name].value < 100)
          case 'weight':
            return (this.state.input[name].value > 50 && this.state.input[name].value < 1500)
          default:
            return RegexVerification[name].test(this.state.input[name].value)
        }
      default: return false
    }
  }

  displayError(name) {
    if (this.state.submitClick) {
      if (!this.isValid(name)) {
        switch (this.state.input[name].type) {
          case 'radio':
            return (
              <div className="error" id="screener_p2_gender_error" tabIndex="-1">Please select a gender</div>
            )
          case 'text':
            switch(name) {
              case 'waist':
                return <div className="error" id="screener_p2_waist_error" tabIndex="-1">Please enter a valid waist circumference in inches</div>
              case 'height':
                return <div className="error" id="screener_p2_height_error" tabIndex="-1">Please enter a valid height in inches</div>
              case 'weight':
                return <div className="error" id="screener_p2_weight_error" tabIndex="-1">Please enter a valid weight in pounds</div>
              default: return null
            }
          default: return null
        }
      }
    }
    return <div></div>
  }

  makeRef(name, ref) {
    this.focusElements[name] = ref
  }

  componentDidMount() {
    window.scrollTo(0, 0)
    if (this.props.history.location.state) {
      this.setState({
        input: this.props.history.location.state
      })
    }
  }

  getCheckBoxLabel(name) {
    switch(name) {
      case 'pregnant':
        return 'Currently Pregnant'
      case 'pregnant-diabetes':
        return 'Have had diabetes while pregnant (gestational diabetes)'
      case 'baby-weight':
        return 'Have had a baby weighing more than 9 lbs at birth'
      case 'drink-male':
        return 'Drink more than 2 alcoholic beverage per day'
      case 'drink-female':
        return 'Drink more than 1 alcoholic beverage per day'
      case 'age':
        return '40 years or older'
      case 'blood-pressure':
        return 'Have high blood pressure or take any medication to manage blood pressure'
      case 'cholesterol':
        return 'Have high cholesterol or take any medication to manage high cholesterol'
      case 'diabetes':
        return 'Have type 2 diabetes, pre-diabetes, or high blood sugar'
      case 'exercise':
        return 'Exercise less than 2.5 hours per week'
      case 'smoke':
        return 'Smoke or use tobacco product (currently or in the last 10 years)'
      default: return null
    }
  }

  showCheckbox(gender, checkboxName) {
    if (gender === 'male' && checkboxName !== 'pregnant' && checkboxName !== 'pregnant-diabetes' && checkboxName !== 'baby-weight' && checkboxName !== 'drink-female') {
      return true
    } else if (gender === '' && checkboxName !== 'pregnant' && checkboxName !== 'pregnant-diabetes' && checkboxName !== 'baby-weight' && checkboxName !== 'drink-male' && checkboxName !== 'drink-female') {
      return true
    } else if (gender === 'female' && checkboxName !== 'drink-male') {
      return true
    }
    return false
  }

  getCheckboxes() {
    const gender = this.state.input.gender.value
    return Object.keys(this.state.input.health.value).map(checkboxName => {
      if (this.showCheckbox(gender, checkboxName)) {
        return <Checkbox key={checkboxName} checkboxRef={this.makeRef.bind(this, "health")} checked={this.state.input.health.value[checkboxName]} onChange={this.handleChange.bind(this, "health", checkboxName)} value={checkboxName} ariaLabelledby={"screener_p2_checkboxes_text"} info={this.getCheckBoxLabel(checkboxName)} for={`${checkboxName}_checkbox`} />              
      }
    })
  }

  _openModal(e) {
    e.preventDefault()
    this.setState({ modalIsOpen: true })
  }

  _closeModal() {
    this.setState({ modalIsOpen: false })
  }

  render() {
    return (
      <div id="screener_p2" className="container">
        <h2 className="screener-header">The Newtopia program is designed to help individuals who have two or more metabolic risk factors and are therefore at risk of developing metabolic syndrome such as diabetes, heart disease or a stroke.</h2>
        <div className="form-input">
        <h3 id="screener_p2_gender_text">What is your gender?</h3>
          <RadioGroup name="gender" initial={this.props.history.location.state ? this.props.history.location.state["gender"].value : ""} radioRef={this.makeRef.bind(this, "gender")} onChange={this.handleChange.bind(this, "gender")} ariaLabelledby="screener_p2_gender_text" ariaDescribedby="screener_p2_gender_error">
            <RadioButton value="female" label="Female" />
            <RadioButton value="male" label="Male" />
          </RadioGroup>
          {this.displayError("gender")}
        </div>
        <div className="form-input">
          <label for="screener_p2_waist" id="screener_p2_waist_text">
            <div className="form-heading">
              What is your waist size (in inches)?
            </div>
            <div>
              Not sure how to measure waist size? &nbsp;
              <button tabIndex="0" className="screener-click" onClick={this.openModal} onContextMenu={this.openModal}>Click here</button>
            </div>
          </label>
          <input ref={this.makeRef.bind(this, "waist")} id="screener_p2_waist" value={this.state.input["waist"].value} type="text" placeholder="Waist size" onChange={this.handleChange.bind(this, "waist")} aria-labelledby="screener_p2_waist_text" aria-describedby="screener_p2_waist_error"/>
          {this.displayError("waist")}
          <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          contentLabel="Waist Modal"
          shouldCloseOnOverlayClick={false}
          className="modal"
          overlayClassName="modal-overlay"
          aria={{ labelledby: "modal-heading" }}
        >
          <div className="screener-modal-body">
            <h3 id="modal-heading">Measuring waist circumference with a measuring tape:</h3>
            <ul className="screener-modal-ul">
              <li className="screener-modal-li">Stand with your feet together.</li>
              <li className="screener-modal-li">Place the tape measure under your clothing and directly over your belly button.</li>
              <li className="screener-modal-li">Breathe out gently. Apply slight tension to the tape measure and check that it is horizontal across the back and front.</li>
              <li className="screener-modal-li">Record your waist circumference in inches.</li>
            </ul>
          </div>
          <div className="screener-button-wrapper">
            <button className="screener-modal-button" onClick={this.closeModal}>Close</button>
          </div>
        </Modal>
        </div>
        <div className="form-input">
          <label for="screener_p2_height" id="screener_p2_height_text" className="form-heading">What is your height (in inches)?</label>
          <input ref={this.makeRef.bind(this, "height")} id="screener_p2_height" value={this.state.input["height"].value} type="text" placeholder="Height" onChange={this.handleChange.bind(this, "height")} aria-labelledby="screener_p2_height_text" aria-describedby="screener_p2_height_error" />
          {this.displayError("height")}
        </div>
        <div className="form-input">
          <label for="screener_p2_weight" id="screener_p2_weight_text" className="form-heading">What is your weight (in pounds)?</label>
          <input ref={this.makeRef.bind(this, "weight")} id="screener_p2_weight" value={this.state.input["weight"].value} type="text" placeholder="Weight" onChange={this.handleChange.bind(this, "weight")} aria-labelledby="screener_p2_weight_text" aria-describedby="screener_p2_weight_error" />
          {this.displayError("weight")}
        </div>
        <div className="form-input" role="radiogroup" aria-labelledby="screener_p2_checkboxes_text">
          <h3 id="screener_p2_checkboxes_text" tabIndex="-1">Please check all that apply.</h3>
          {this.getCheckboxes()}
        </div>
        <h3>Click below to find out if you are eligible.</h3>
        
        <br />
        <Controls className="screener-button" nextLabel="ARE YOU ELIGIBLE?" next={this.next} />
      </div>
    )
  }
}